// src/components/pos/POSCart.js
import { PAYMENT_METHODS } from './pos.constants'

function CartIcon({ path, size = 14, color = 'currentColor', sw = 1.8 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round">
      <path d={path} />
    </svg>
  )
}

export default function POSCart({
  cart, subtotal, discountAmount, afterDiscount, taxAmount,
  oldGoldDeduction, storeCreditUsed, total, change, balanceDue,
  options, setOptions, customer,
  selling, availablePayments, isJewellery, sym, posMode, goldRates,
  onUpdateQty, onUpdatePrice, onRemove,
  onCharge, onClearSale, onHoldOrder,
  onOpenNumpad, onOpenCustomItem, onOpenPartial, onOpenVoid, onOpenReturn, onOpenShiftClose,
  staffSession,
}) {
  const setOpt = (k, v) => setOptions(o => ({ ...o, [k]: v }))

  const activePayments = availablePayments.map(k => PAYMENT_METHODS.find(p => p.key === k)).filter(Boolean)
  const canVoid = staffSession?.role === 'owner' || staffSession?.role === 'manager' || !staffSession

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%' }}>

      {/* ── Cart header ── */}
      <div style={{ padding:'12px 14px', borderBottom:'1px solid var(--border)', background:'var(--primary)', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
          <CartIcon path="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-10 2a2 2 0 100 4 2 2 0 000-4z" size={15} color="#fff" sw={2} />
          <span style={{ color:'#fff', fontSize:'13px', fontWeight:700 }}>
            Cart {cart.length > 0 && `(${cart.length})`}
          </span>
        </div>
        <div style={{ display:'flex', gap:'6px' }}>
          {cart.length > 0 && (
            <button onClick={onOpenCustomItem}
              style={{ padding:'4px 9px', borderRadius:'var(--radius-sm)', border:'1px solid rgba(255,255,255,0.3)', background:'transparent', color:'#fff', fontSize:'11px', fontWeight:600, cursor:'pointer' }}>
              + Custom
            </button>
          )}
          {cart.length > 0 && (
            <button onClick={onClearSale}
              style={{ padding:'4px 9px', borderRadius:'var(--radius-sm)', border:'1px solid rgba(255,255,255,0.3)', background:'rgba(255,255,255,0.1)', color:'#fff', fontSize:'11px', fontWeight:600, cursor:'pointer' }}>
              Clear
            </button>
          )}
        </div>
      </div>

      {/* ── Cart items ── */}
      <div style={{ flex:1, overflowY:'auto', padding: cart.length === 0 ? 0 : '6px 0' }}>
        {cart.length === 0 ? (
          <div style={{ padding:'48px 20px', textAlign:'center' }}>
            <CartIcon path="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-10 2a2 2 0 100 4 2 2 0 000-4z" size={36} color="var(--border)" sw={1.2} />
            <div style={{ fontSize:'13px', fontWeight:600, color:'var(--text-primary)', marginTop:'12px', marginBottom:'4px' }}>Cart is empty</div>
            <div style={{ fontSize:'12px', color:'var(--text-muted)' }}>Add products from the centre panel</div>
          </div>
        ) : cart.map((item, idx) => (
          <div key={item.cartId} style={{ padding:'10px 14px', borderBottom:'1px solid var(--border)', background:'var(--bg-card)' }}>
            <div style={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:'7px' }}>
              <div style={{ flex:1, minWidth:0, marginRight:'8px' }}>
                <div style={{ fontSize:'12.5px', fontWeight:600, color:'var(--text-primary)', lineHeight:1.3 }}>{item.name}</div>
                {item.product_code && (
                  <div style={{ fontSize:'10.5px', color:'var(--text-muted)', fontFamily:'monospace', marginTop:'1px' }}>{item.product_code}</div>
                )}
                {/* Jewellery details */}
                {item.gold_karat && (
                  <div style={{ fontSize:'10.5px', color:'var(--warning)', marginTop:'2px', fontWeight:600 }}>
                    {item.gold_karat} · {item.gold_weight}g
                    {item.hallmark_number && ` · #${item.hallmark_number}`}
                  </div>
                )}
                {item.is_service && (
                  <span style={{ fontSize:'10px', fontWeight:700, padding:'1px 6px', borderRadius:'var(--radius-full)', background:'var(--primary-light)', color:'var(--primary)', display:'inline-block', marginTop:'2px' }}>Service</span>
                )}
              </div>
              <button onClick={() => onRemove(item.cartId)}
                style={{ width:'20px', height:'20px', borderRadius:'var(--radius-sm)', background:'#FEF2F2', border:'none', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                <CartIcon path="M6 18L18 6M6 6l12 12" color="var(--error)" size={10} sw={2.5} />
              </button>
            </div>

            {/* Qty + price row */}
            <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
              {/* Qty controls */}
              <div style={{ display:'flex', alignItems:'center', gap:'3px', flexShrink:0 }}>
                <button onClick={() => onUpdateQty(item.cartId, item.quantity - 1)}
                  style={{ width:'24px', height:'24px', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)', background:'var(--bg-muted)', fontSize:'14px', fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-primary)' }}>−</button>
                {/* Tap qty to open numpad */}
                <button onClick={() => onOpenNumpad(item.cartId, 'qty')}
                  style={{ width:'32px', height:'24px', borderRadius:'var(--radius-sm)', border:'1px solid var(--primary-border)', background:'var(--primary-light)', fontSize:'12.5px', fontWeight:700, cursor:'pointer', color:'var(--primary)', textAlign:'center' }}>
                  {item.quantity}
                </button>
                <button onClick={() => onUpdateQty(item.cartId, item.quantity + 1)}
                  style={{ width:'24px', height:'24px', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)', background:'var(--bg-muted)', fontSize:'14px', fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-primary)' }}>+</button>
              </div>

              {/* Unit price — tap to edit */}
              <button onClick={() => onOpenNumpad(item.cartId, 'price')}
                style={{ flex:1, padding:'4px 8px', borderRadius:'var(--radius-sm)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'12px', fontWeight:600, color:'var(--text-primary)', cursor:'pointer', textAlign:'left', display:'flex', alignItems:'center', gap:'4px' }}>
                <span style={{ color:'var(--text-muted)', fontSize:'11px' }}>{sym}</span>
                {Number(item.unit_price).toLocaleString()}
              </button>

              {/* Line total */}
              <div style={{ fontSize:'13px', fontWeight:700, color:'var(--text-primary)', flexShrink:0, minWidth:'52px', textAlign:'right' }}>
                {sym}{(item.unit_price * item.quantity).toLocaleString()}
              </div>
            </div>

            {/* Stock warning */}
            {!item.is_service && item.quantity > item.stock && (
              <div style={{ fontSize:'11px', color:'var(--error)', marginTop:'4px', display:'flex', alignItems:'center', gap:'4px' }}>
                <CartIcon path="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01" color="var(--error)" size={11} sw={2} />
                Only {item.stock} in stock
              </div>
            )}
          </div>
        ))}

        {/* Custom item button when cart has items */}
        {cart.length > 0 && (
          <button onClick={onOpenCustomItem}
            style={{ width:'100%', padding:'10px 14px', border:'none', borderBottom:'1px solid var(--border)', background:'var(--bg-muted)', fontSize:'12px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer', textAlign:'left', display:'flex', alignItems:'center', gap:'8px' }}>
            <CartIcon path="M12 5v14M5 12h14" color="var(--text-muted)" size={13} sw={2} />
            Add custom item
          </button>
        )}
      </div>

      {/* ── Order summary + payment ── */}
      {cart.length > 0 && (
        <div style={{ borderTop:'1px solid var(--border)', background:'var(--bg-card)', flexShrink:0 }}>

          {/* Summary rows */}
          <div style={{ padding:'12px 14px 8px', display:'flex', flexDirection:'column', gap:'5px' }}>
            <SummaryRow label="Subtotal"   value={`${sym}${subtotal.toLocaleString()}`} />
            {discountAmount > 0 && <SummaryRow label={`Discount (${options.discountPercent}%)`} value={`−${sym}${discountAmount.toLocaleString()}`} color="var(--error)" />}
            {taxAmount > 0      && <SummaryRow label={`${options.taxType} (${options.taxPercent}%)`} value={`+${sym}${taxAmount.toLocaleString()}`} color="var(--primary)" />}
            {oldGoldDeduction > 0 && <SummaryRow label="Old gold exchange" value={`−${sym}${oldGoldDeduction.toLocaleString()}`} color="var(--warning)" />}
            {storeCreditUsed > 0  && <SummaryRow label="Store credit used" value={`−${sym}${storeCreditUsed.toLocaleString()}`} color="var(--success)" />}
            <div style={{ borderTop:'1px solid var(--border)', paddingTop:'8px', display:'flex', justifyContent:'space-between', alignItems:'baseline' }}>
              <span style={{ fontSize:'13px', fontWeight:700, color:'var(--text-primary)' }}>Total</span>
              <span style={{ fontSize:'20px', fontWeight:800, color:'var(--primary)', letterSpacing:'-0.5px' }}>{sym}{total.toLocaleString()}</span>
            </div>
          </div>

          {/* Payment method buttons */}
          <div style={{ padding:'0 14px 10px' }}>
            <div style={{ fontSize:'10px', fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.08em', marginBottom:'7px' }}>Payment method</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:'5px', marginBottom:'8px' }}>
              {activePayments.filter(p => p.key !== 'Split').map(pm => (
                <button key={pm.key} onClick={() => { setOpt('paymentMethod', pm.key); setOpt('splitEnabled', false) }}
                  style={{ padding:'5px 10px', borderRadius:'var(--radius-md)', border:'1.5px solid', borderColor: options.paymentMethod === pm.key && !options.splitEnabled ? pm.color : 'var(--border)', background: options.paymentMethod === pm.key && !options.splitEnabled ? pm.bg : 'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color: options.paymentMethod === pm.key && !options.splitEnabled ? pm.color : 'var(--text-muted)', cursor:'pointer', transition:'all 0.1s', flexShrink:0 }}>
                  {pm.label}
                </button>
              ))}
              {/* Split toggle */}
              <button onClick={() => setOpt('splitEnabled', !options.splitEnabled)}
                style={{ padding:'5px 10px', borderRadius:'var(--radius-md)', border:'1.5px solid', borderColor: options.splitEnabled ? 'var(--primary)' : 'var(--border)', background: options.splitEnabled ? 'var(--primary-light)' : 'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color: options.splitEnabled ? 'var(--primary)' : 'var(--text-muted)', cursor:'pointer' }}>
                Split
              </button>
            </div>

            {/* Split payment rows */}
            {options.splitEnabled ? (
              <div style={{ display:'flex', flexDirection:'column', gap:'7px', marginBottom:'8px' }}>
                {[
                  { method: options.paymentMethod,  setMethod: v => setOpt('paymentMethod', v),  amount: options.amountPaid,  setAmount: v => setOpt('amountPaid', v),  label:'Method 1' },
                  { method: options.paymentMethod2, setMethod: v => setOpt('paymentMethod2', v), amount: options.amountPaid2, setAmount: v => setOpt('amountPaid2', v), label:'Method 2' },
                ].map((row, i) => (
                  <div key={i} style={{ display:'flex', gap:'6px', alignItems:'center' }}>
                    <select value={row.method} onChange={e => row.setMethod(e.target.value)}
                      style={{ flex:1, border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', padding:'6px 8px', fontSize:'12px', background:'var(--bg-card)', color:'var(--text-primary)', outline:'none' }}>
                      {activePayments.filter(p => p.key !== 'Split').map(pm => <option key={pm.key} value={pm.key}>{pm.label}</option>)}
                    </select>
                    <input type="number" placeholder={sym + '0'} value={row.amount} onChange={e => row.setAmount(e.target.value)}
                      style={{ width:'80px', border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', padding:'6px 8px', fontSize:'12px', background:'var(--bg-card)', color:'var(--text-primary)', outline:'none', textAlign:'right' }} />
                  </div>
                ))}
                {balanceDue > 0 && <div style={{ fontSize:'11.5px', color:'var(--error)', fontWeight:600 }}>Balance due: {sym}{balanceDue.toLocaleString()}</div>}
              </div>
            ) : (
              /* Cash: amount given + change */
              options.paymentMethod === 'Cash' && (
                <div style={{ display:'flex', gap:'6px', alignItems:'center', marginBottom:'8px' }}>
                  <input type="number" placeholder="Amount given" value={options.amountPaid} onChange={e => setOpt('amountPaid', e.target.value)}
                    style={{ flex:1, border:'1px solid var(--border)', borderRadius:'var(--radius-sm)', padding:'7px 10px', fontSize:'13px', background:'var(--bg-card)', color:'var(--text-primary)', outline:'none' }}
                    onFocus={e => e.target.style.borderColor='var(--primary)'}
                    onBlur={e => e.target.style.borderColor='var(--border)'} />
                  {change > 0 && (
                    <div style={{ flexShrink:0, padding:'7px 10px', borderRadius:'var(--radius-sm)', background:'#F0FDF4', border:'1px solid #BBF7D0', fontSize:'12.5px', fontWeight:700, color:'var(--success)' }}>
                      Change: {sym}{change.toLocaleString()}
                    </div>
                  )}
                </div>
              )
            )}
          </div>

          {/* ── Charge button ── */}
          <div style={{ padding:'0 14px 12px' }}>
            <button onClick={onCharge} disabled={selling || cart.length === 0}
              style={{ width:'100%', padding:'14px', borderRadius:'var(--radius-lg)', background: cart.length === 0 ? 'var(--border)' : 'var(--success)', border:'none', fontSize:'15px', fontWeight:800, color:'#fff', cursor: cart.length === 0 ? 'not-allowed' : 'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'10px', letterSpacing:'-0.3px', transition:'opacity 0.1s', opacity: selling ? 0.7 : 1 }}>
              {selling ? (
                <>
                  <div style={{ width:'16px', height:'16px', borderRadius:'50%', border:'2.5px solid #fff', borderTopColor:'transparent', animation:'pos-spin 0.7s linear infinite' }} />
                  Processing...
                </>
              ) : (
                <>
                  <CartIcon path="M13 10V3L4 14h7v7l9-11h-7z" color="#fff" size={18} sw={2.5} />
                  Charge {sym}{total.toLocaleString()}
                </>
              )}
            </button>

            {/* Secondary actions */}
            <div style={{ display:'flex', gap:'6px', marginTop:'7px' }}>
              <button onClick={() => onHoldOrder()}
                style={{ flex:1, padding:'8px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'5px' }}>
                <CartIcon path="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z" color="var(--text-muted)" size={12} sw={2} />
                Hold
              </button>
              <button onClick={onOpenReturn}
                style={{ flex:1, padding:'8px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'5px' }}>
                <CartIcon path="M1 4v6h6M23 20v-6h-6M20.49 9A9 9 0 005.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 013.51 15" color="var(--text-muted)" size={12} sw={2} />
                Return
              </button>
              {canVoid && (
                <button onClick={onOpenVoid}
                  style={{ flex:1, padding:'8px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'5px' }}>
                  <CartIcon path="M18 6L6 18M6 6l12 12" color="var(--text-muted)" size={12} sw={2} />
                  Void
                </button>
              )}
              <button onClick={onOpenShiftClose}
                style={{ flex:1, padding:'8px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'5px' }}>
                <CartIcon path="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" color="var(--text-muted)" size={12} sw={2} />
                End Day
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Empty cart actions */}
      {cart.length === 0 && (
        <div style={{ padding:'12px 14px', borderTop:'1px solid var(--border)', display:'flex', flexDirection:'column', gap:'6px', flexShrink:0 }}>
          <button onClick={onOpenCustomItem}
            style={{ width:'100%', padding:'10px', borderRadius:'var(--radius-md)', border:'1.5px dashed var(--border)', background:'var(--bg-muted)', fontSize:'12.5px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:'6px' }}>
            <CartIcon path="M12 5v14M5 12h14" color="var(--text-muted)" size={13} sw={2} />
            Add custom item
          </button>
          <div style={{ display:'flex', gap:'6px' }}>
            <button onClick={onOpenReturn}
              style={{ flex:1, padding:'8px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>
              Process Return
            </button>
            <button onClick={onOpenShiftClose}
              style={{ flex:1, padding:'8px', borderRadius:'var(--radius-md)', border:'1px solid var(--border)', background:'var(--bg-card)', fontSize:'11.5px', fontWeight:600, color:'var(--text-muted)', cursor:'pointer' }}>
              End of Day
            </button>
          </div>
        </div>
      )}

      <style>{`@keyframes pos-spin { to { transform: rotate(360deg) } }`}</style>
    </div>
  )
}

function SummaryRow({ label, value, color }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
      <span style={{ fontSize:'12px', color:'var(--text-muted)' }}>{label}</span>
      <span style={{ fontSize:'12.5px', fontWeight:600, color: color || 'var(--text-primary)' }}>{value}</span>
    </div>
  )
}